import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from 'nucleus-widgets/lib/BaseWidget';
import { connect } from 'react-redux';
import NucleusCountdownTimerWidget from 'nucleus-widgets/lib/CountdownTimer/CountdownTimerWidget.js';

/**
* A widget to display a countdown timer for either the event start date or the
* registration close date.
*/
class CountdownTimerWidget extends BaseWidget {
  static displayName = 'CountdownTimerWidget';
  static propTypes = {
    config: PropTypes.shape({}), // have different Component for flip and circle ???
    style: PropTypes.object,
    translate: PropTypes.func
  };
  render() {
    const { config, closeDate, startDate, ...other } = this.props;
    let endDate;
    switch (config.dateSource) {
      case 'startDate':
        endDate = startDate;
        break;
      case 'closeDate':
        endDate = closeDate;
        break;
      default:
        endDate = new Date();
    }
    return (
      <NucleusCountdownTimerWidget {...other}
        config={{ ...config, date: endDate }} />
    );
  }
}

export default connect((state) => {
  return {
    startDate: state.event.startDate,
    closeDate: state.event.closeDate
  };
})(CountdownTimerWidget);



// WEBPACK FOOTER //
// ./~/event-widgets/lib/CountdownTimer/CountdownTimerWidget.js